import { render, staticRenderFns } from "./OverlayError.vue?vue&type=template&id=c15d5bc0&scoped=true"
import script from "./OverlayError.vue?vue&type=script&lang=js"
export * from "./OverlayError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15d5bc0",
  null
  
)

export default component.exports